export class SnackbarData {
  constructor(public message: string, public icon: string) {
  }
}
